export default __webpack_public_path__ + "static/B0058-f4b0e34dbe854e588759fd56f34c739f.png";